import { useEffect, useState } from 'react';


export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToApply = () => {
    const el = document.getElementById('apply');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-white border-b border-warm-border' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        <div className="flex items-center">
          <img
            src="https://storage.readdy-site.link/project_files/777ff6c9-ee60-489f-b76a-eca20a2d3e36/921865f1-eb94-43ab-9eae-5b95ce24bd25_-2026-04-01-21.38.52.png?v=dc4243f587326e85e9668878523bfb8a"
            alt="Chammi Inc."
            className="h-8 w-auto object-contain"
          />
        </div>
        <button
          onClick={scrollToApply}
          className={`whitespace-nowrap cursor-pointer text-xs tracking-widest px-5 py-2.5 rounded-full border transition-all duration-300 ${
            scrolled
              ? 'border-terracotta text-terracotta hover:bg-terracotta hover:text-white'
              : 'border-white/70 text-white hover:bg-white/20'
          }`}
        >
          応募する
        </button>
      </div>
    </header>
  );
}
